module.exports = __webpack_public_path__ + "static/img/rush_buy_capsule.179cad62.gif";